<script>
import Multiselect from "@vueform/multiselect";
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import 'vue3-lottie/dist/style.css'
import exportFromJSON from "export-from-json"
import {helpers, required} from "@vuelidate/validators";
import moment from "moment/moment";
import useVuelidate from "@vuelidate/core";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Paletes",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  setup() {
    return { v$: useVuelidate() };
  },
  components: { Layout, PageHeader, Loader, Multiselect  },
  data() {
    return {

      title: 'Paletes',
      items: [
        {
          text: 'Administrativo',
          href: '/',
        },
        {
          text: 'Paletes',
          active: true,
        },
      ],
      errosValid: null,
      loadingList: true,
      loadingGraph: true,
      paletesTable: null,
      pesqTextFilter: '',
      statusFilter: 'T',

      regSelecionado: {},
      enderecoData: null,
      dtlistPesqEndereco: null,

      submitted: false,
      showModal: false,
      paleteEnderecosData: null,
      loadingPaleteEnderecos: false,
      showAddEndereco: false,
      paleteEnderecoData: {},

      showModalEdita: false,
      regSelecionadoEdita: {},

    }
  },

  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      status: {
        required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
    }
  },

  methods: {

    pesqEndereco(evt) {
      console.log('pesqEndereco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        // this.loadingPedTipo = true
        // this.wmsOsItemSepData.endwms = ''
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "palete", origem_id: null }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqEndereco = res.data
        })
      }
    },


    escolheuEndereco() {
      console.log('escolheuEndereco')
      // this.loadingCondPgto = true
      // console.log(this.wmsOsItemSepData.endwms)
      api.get(`${getBaseUrl()}api/endercod`, {
        params: { coddata: this.regSelecionado.endwms }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.enderecoData = res.data[0]
      })
    },

    informouNovoEnd(){
      this.formSubmitEdita()
    },

    alterarEndereco(){
      console.log('alterarEndereco')

      this.showModalEdita = true
    },


    informouPalete(){
      console.log('informouPalete')
      console.log(this.regSelecionadoEdita.codigo)
      api.get(`${getBaseUrl()}api/palcod`, {
        params: {
          coddata: this.regSelecionadoEdita.codigo
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        // this.regSelecionadoEdita = res.data[0]
        this.regSelecionadoEdita = res.data[0]
        this.$refs.novoendereco.focus()



      })
    },

    formSubmitEdita() {

      console.log('formSubmitEdita_0')
      console.log(this.regSelecionadoEdita)
      this.submitted = true

      if (this.regSelecionadoEdita.endwms) {

        console.log('formSubmitEdita_validado')

        // this.showModalEdita = false
        // this.alterouReg(this.regSelecionadoEdita)

        // console.log(regSelecionadoEdita)
        this.loadingList = true


            this.errosValid = []
        api.post(`${getBaseUrl()}api/palnovoend`, {
          paleteData: this.regSelecionadoEdita
        }).then((res) => {
          console.log('then axios palnovoend')
          console.log(res)
          // this.produtoData = res.data[0]
          // this.loadingList = false

          // Swal.fire({
          //   position: "top-end",
          //   icon: "success",
          //   title: "Informações salvas com sucesso!",
          //   showConfirmButton: false,
          //   timer: 1500
          // })
          this.regSelecionadoEdita = {}
          this.submitted = false

          this.$refs.palete.focus()

          this.atualizaDataList()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingList = false
        })



      }

    },


    salvaPaleteEnder() {
      console.log('salvaPaleteEnder')

      this.paleteEnderecoData.codpalete = this.regSelecionado.codigo

      api.post(`${getBaseUrl()}api/palender`, {
        paleteEnderData: this.paleteEnderecoData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        this.paleteEnderecosData = res.data[0]


        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        // this.atualizaDataList()

      })
    },

    gerarPaletes() {
      console.log('gerarPaletes')
      // this.$refs.childTable.setCriarNova(true)
      this.regSelecionado = {}
      this.submitted = false
      this.showModal = true

    },

    exportExcel(){
      console.log('exportExcel')
      const data = this.paletesTable
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    atualizaDataList(){
      this.loadingList = true
      api.get(`${getBaseUrl()}api/paletes`, {
        params: {
          'q': this.pesqTextFilter,
          's': this.statusFilter
        }
      }).then((res) => {
        console.log('then axios')
        // console.log(res.data)
        if (res.data.error){
          console.log(res.data.error)
          this.$router.push(`/faltapermissao`);
        }else{
          this.paletesTable = res.data[0]
          this.title = `(${this.paletesTable.length}) Paletes`
          this.loadingList = false
          this.loadingGraph = false
        }
      })
    },

    deletouReg(dataID){
      console.log('deletouReg_pai dataid:')
      console.log(dataID)

      this.loadingList = true
      api.delete(`${getBaseUrl()}api/palete`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },


    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.showModalEdita = true
      //
      //
      this.regSelecionadoEdita = this.paletesTable.find((reg) => reg.id === dataID);
      // console.log('regSelecionado: ')
      // console.log(this.regSelecionado)

      api.get(`${getBaseUrl()}api/palete`, {
        params: {
          iddata: dataID
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        this.regSelecionadoEdita = res.data[0]

        // this.paleteEnderecosData = res.data[1]

        // if (res.data.error){
        //   console.log(res.data.error)
        //   this.$router.push(`/faltapermissao`);
        // }else{
        //   this.paletesTable = res.data[0]
        //   this.title = `(${this.paletesTable.length}) Paletes`
        //   this.loadingList = false
        //   this.loadingGraph = false
        // }
      })

    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.deletouReg(dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      console.log(this.regSelecionado)
      this.submitted = true

      if (this.regSelecionado.nopalini && this.regSelecionado.nopalfim) {
        console.log('formSubmit_validado')
        this.showModal = false
        // this.alterouReg(this.regSelecionado)

        // console.log(regSelecionado)
        this.loadingList = true

        this.errosValid = []
        api.post(`${getBaseUrl()}api/palgera`, {
          paleteData: this.regSelecionado
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.produtoData = res.data[0]
          // this.loadingList = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.atualizaDataList()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingList = false
        })



      }
    },


    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },



  mounted() {
    console.log('mounted paletes-list_0')


    console.log('process.env.VERCEL_TESTE_2')
    console.log(process.env)




    this.atualizaDataList()
  },
}
</script>

<template>

  <Layout>

    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                      <option value="SE">Sem Endereço</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                <div class="text-sm-end">

<!--                  <router-link :to="`/palete/editar/0`">-->
<!--                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >-->
<!--                      <i class="mdi mdi-plus me-1"></i> Novo Palete-->
<!--                    </button>-->
<!--                  </router-link>-->
<!--                  <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="alterarEndereco">-->
<!--                    <i class="mdi mdi-plus me-1"></i> Alterar Endereço-->
<!--                  </button>-->


                  <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="gerarPaletes">
                    <i class="mdi mdi-plus me-1"></i> Gerar Paletes
                  </button>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <div class="table-responsive mb-0">
              <table class="table align-middle table-nowrap" v-if="paletesTable">
                <thead class="table-light">
                <tr>

                  <th class="align-middle">ID</th>
                  <th class="align-middle">Código</th>
                  <th class="align-middle">Endereço</th>
                  <th class="align-middle">Data</th>
                  <th class="align-middle">Status</th>
                  <th class="align-middle">Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in paletesTable" :key="data.id">
                  <td>
                    <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">{{
                        data.id
                      }}</a>
                  </td>
                  <td>{{ data.codigo }} </td>
                  <td>{{ data.endereco }} </td>
                  <td>{{ formatDateTime(data.created_at) }} </td>

                  <td>
              <span class="badge badge-pill badge-soft-success font-size-11 badge-soft-success">
                Ativo
              </span>
                  </td>

                  <td>
                    <div class="button-items">
<!--                      <b-button variant="outline-success" @click="editar(data.id)">-->
<!--                        <i class="mdi mdi-pencil d-block font-size-16"></i>-->
<!--                      </b-button>-->
                      <b-button variant="outline-danger" @click="deletar(data.id)">
                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                      </b-button>
                    </div>
                  </td>

                </tr>
                </tbody>
              </table>


            </div>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>

              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

    <b-modal size="lg"
             :title="regSelecionado.id != null ? `Editar Palete (${ regSelecionado.id })` : 'Gerar Novos Paletes'" v-model="showModal"
             hide-footer>

      <form @submit.prevent="formSubmit">
        <div class="row">

          <div class="col-6">
            <div class="mb-3">
              <label for="nopalini">Palete Inicial</label>
              <input
                  id="nopalini"
                  v-model="regSelecionado.nopalini"
                  type="number"
                  class="form-control"
                  placeholder="Inserir palete inicial"
                  :class="{'is-invalid': submitted && !regSelecionado.nopalini,}"/>
              <div
                  v-if="submitted && !regSelecionado.nopalini"
                  class="invalid-feedback">
                <span>
                  Campo palete inicial obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="nopalfim">Palete Final</label>
              <input
                  id="nopalfim"
                  v-model="regSelecionado.nopalfim"
                  type="number"
                  class="form-control"
                  placeholder="Inserir palete final"
                  :class="{'is-invalid': submitted && !regSelecionado.nopalfim,}"/>
              <div
                  v-if="submitted && !regSelecionado.nopalfim"
                  class="invalid-feedback">
                <span>
                  Campo palete final obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>




        </div>


        <div class="row  mt-2">
          <div class="text-start">
            <a href="javascript: void(0);" @click="showAddEndereco = !showAddEndereco" >
              <i class="bx bx-pencil font-size-16 align-middle me-2"></i>
              Palete com Endereço Fixo
            </a>
          </div>
        </div>

        <div v-if="showAddEndereco">
          <div class="row  mt-4">

            <div class="mb-2">


              <div class="row">

<!--                <div class="col-xl-6 col-sm-6">-->
<!--                  <div class="mb-3">-->
<!--                    <label class="card-radio-label mb-2">-->
<!--                      <input-->
<!--                          type="text"-->
<!--                          v-model="regSelecionado.endereco"-->
<!--                          name="codender"-->
<!--                          id="codender"-->
<!--                          class="form-control"-->
<!--                      />-->
<!--                    </label>-->
<!--                    <div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="col-xl-6 col-sm-6">-->
<!--                  <div class="mb-3">-->

<!--                    <b-button variant="success" class="ms-1" @click="salvaPaleteEnder">-->
<!--                      <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
<!--                      Confirmar Novo Endereço-->
<!--                    </b-button>-->
<!--                  </div>-->
<!--                </div>-->



                <div class="col-md-6">
                  <div class="mb-3">
                    <div class="mb-2">
                      <span class="text-black font-18 ">Novo Endereço</span>
                    </div>

                    <multiselect id="endereco"
                                 @search-change="pesqEndereco"
                                 @select="escolheuEndereco"
                                 v-model="regSelecionado.endwms"
                                 placeholder="Pesquisar endereços"
                                 :options="dtlistPesqEndereco"
                                 :searchable="true"
                                 label="descricao"
                                 track-by="descricao"
                                 value-prop="descricao">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                                      <span class="mx-4" >
                              {{ slotProps.option.endereco }}
                            </span>
                                    </div>
                                    <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                                    <span class="mx-4" >
                            </span>
                          <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submitted && !regSelecionado.endereco">
                      <span class="text-danger font-size-11">Campo endereço obrigatório, favor preencher.</span>
                    </div>


                  </div>

                </div>


              </div>
            </div>
          </div>

        </div>

        <div class="row" v-if="loadingPaleteEnderecos">
          <div class="col-12 text-center">
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
          </div>
        </div>



        <div class="table-responsive" v-if="paleteEnderecosData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Endereços</th>
              <th scope="col" class="">ID</th>
              <th scope="col" class="">Palete</th>
              <th scope="col" class="">Endereço</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in paleteEnderecosData" :key="data.id">
              <td></td>
              <td>
                <div>
                  <h5 class="text-truncate font-size-14">
                    {{ data.id }}
                  </h5>
                </div>
              </td>


              <td class="">{{ data.codpalete }}</td>
              <td class="">{{ data.codender }}</td>
            </tr>

<!--            <tr>-->
<!--              <td colspan="4">-->
<!--                <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>-->
<!--              </td>-->
<!--              <td class="text-end"> {{ formatDecimal(somaQtdVolumes) }}</td>-->
<!--            </tr>-->

<!--            <tr>-->
<!--              <td colspan="4">-->
<!--                <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>-->
<!--              </td>-->
<!--              <td class="font-size-14 text-end"> {{ formatDecimal(somaPesoVolumes) }}</td>-->
<!--            </tr>-->

            </tbody>
          </table>
        </div>


        <div class="text-end mt-3">
          <b-button variant="light" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button variant="success" class="ms-1" @click="formSubmit">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Gerar
          </b-button>
        </div>

      </form>

    </b-modal>




    <b-modal size="lg"
             :title="regSelecionadoEdita.id != null ? `Editar Palete (${ regSelecionadoEdita.id }) Endereço Fixo` : 'Associar Endereço'" v-model="showModalEdita"
             hide-footer>

      <form @submit.prevent="formSubmitEdita">
        <div class="row">

          <div class="col-6">
            <div class="mb-3">
              <label for="codigo">Palete:</label>
              <input
                  id="codigo"
                  ref="palete"
                  v-model="regSelecionadoEdita.codigo"
                  type="number"
                  class="form-control"
                  @keypress.enter="informouPalete"
                  placeholder="Palete"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="nopalfim">Endereço Atual</label>
              <input
                  id="nopalfim"
                  v-model="regSelecionadoEdita.endereco"
                  type="text"
                  class="form-control"
                  :disabled="true"
                  placeholder="Endereço atual"/>
            </div>
          </div>

        </div>




          <div class="row  mt-4">

            <div class="mb-2">

              <div class="row">

                <div class="col-md-6">
                  <div class="mb-3">
                    <div class="mb-2">
                      <span class="text-black font-18 ">Novo Endereço</span>
                    </div>

                    <multiselect id="endereco"
                                 ref="novoendereco"
                                 @search-change="pesqEndereco"
                                 @select="escolheuEndereco"
                                 v-model="regSelecionadoEdita.endwms"
                                 placeholder="Pesquisar endereços"
                                 :options="dtlistPesqEndereco"
                                 :searchable="true"
                                 label="descricao"
                                 track-by="descricao"
                                 value-prop="descricao">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                            <span class="mx-4" >
                              {{ slotProps.option.endereco }}
                            </span>
                          </div>
                          <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                          <span class="mx-4" >
                            </span>
                          <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submitted && !regSelecionadoEdita.endwms">
                      <span class="text-danger font-size-11">Campo endereço obrigatório, favor preencher.</span>
                    </div>


                  </div>

                </div>

<!--                <div class="col-xl-6 col-sm-6">-->
<!--                  <div class="mb-3">-->
<!--                    <label class="card-radio-label mb-2">-->
<!--                      <input-->
<!--                          type="text"-->
<!--                          ref="novoendereco"-->
<!--                          v-model="regSelecionadoEdita.novoendereco"-->
<!--                          name="codender"-->
<!--                          id="codender"-->
<!--                          @keypress.enter="informouNovoEnd"-->
<!--                          class="form-control"-->
<!--                      />-->
<!--                    </label>-->
<!--                    <div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

              </div>
            </div>

        </div>

        <div class="row" v-if="loadingPaleteEnderecos">
          <div class="col-12 text-center">
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
          </div>
        </div>



        <div class="table-responsive" v-if="paleteEnderecosData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Endereços</th>
              <th scope="col" class="">ID</th>
              <th scope="col" class="">Palete</th>
              <th scope="col" class="">Endereço</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in paleteEnderecosData" :key="data.id">
              <td></td>
              <td>
                <div>
                  <h5 class="text-truncate font-size-14">
                    {{ data.id }}
                  </h5>
                </div>
              </td>


              <td class="">{{ data.codpalete }}</td>
              <td class="">{{ data.codender }}</td>
            </tr>

            <!--            <tr>-->
            <!--              <td colspan="4">-->
            <!--                <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>-->
            <!--              </td>-->
            <!--              <td class="text-end"> {{ formatDecimal(somaQtdVolumes) }}</td>-->
            <!--            </tr>-->

            <!--            <tr>-->
            <!--              <td colspan="4">-->
            <!--                <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>-->
            <!--              </td>-->
            <!--              <td class="font-size-14 text-end"> {{ formatDecimal(somaPesoVolumes) }}</td>-->
            <!--            </tr>-->

            </tbody>
          </table>
        </div>


        <div class="text-end mt-3">
          <b-button variant="light" @click="showModalEdita = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button variant="success" class="ms-1" @click="formSubmitEdita">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </form>

    </b-modal>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>


  </Layout>
</template>
